import { Product, VariantGroup, Variant } from "@/types/types";
import {
  OFFERTYPE_REDUCED,
  OFFERTYPE_PROMOTION,
  OFFERTYPESUMMARY_REDUCED,
  OFFERTYPESUMMARY_PROMOTION,
  OFFERTYPESUMMARY_SELECTED_REDUCED,
  OFFERTYPESUMMARY_SELECTED_PROMOTION,
} from "@/constants/constants";

const isVariantReducedToClear = (variant: Variant): boolean => {
  return variant.price && variant.price?.offerType
    ? variant.price?.offerType === OFFERTYPE_REDUCED
    : false;
};

const isVariantPromotional = (variant: Variant): boolean => {
  return variant.price && variant.price?.offerType
    ? variant.price?.offerType === OFFERTYPE_PROMOTION
    : false;
};

const isAllVariantsReduced = (product: Product): boolean =>
  product.variantPriceRange?.offerTypeSummary === OFFERTYPESUMMARY_REDUCED;

const isAllVariantsSave = (product: Product): boolean =>
  product.variantPriceRange?.offerTypeSummary === OFFERTYPESUMMARY_PROMOTION;

const isVariantGroupReducedFor = (
  variantGroup: VariantGroup,
  offerTypeSummary: string,
) => {
  return variantGroup?.variantPriceRange?.offerTypeSummary === offerTypeSummary;
};

const isAllVariantsReducedForColour = (variantGroup: VariantGroup): boolean =>
  isVariantGroupReducedFor(variantGroup, OFFERTYPESUMMARY_REDUCED);

const isSomeVariantsReducedForColour = (variantGroup: VariantGroup): boolean =>
  isVariantGroupReducedFor(variantGroup, OFFERTYPESUMMARY_SELECTED_REDUCED);

const isAllVariantsSaveForColour = (variantGroup: VariantGroup): boolean =>
  isVariantGroupReducedFor(variantGroup, OFFERTYPESUMMARY_PROMOTION);

const isSomeVariantsSaveForColour = (variantGroup: VariantGroup): boolean =>
  isVariantGroupReducedFor(variantGroup, OFFERTYPESUMMARY_SELECTED_PROMOTION);

export {
  isVariantReducedToClear,
  isVariantPromotional,
  isAllVariantsReduced,
  isAllVariantsSave,
  isAllVariantsReducedForColour,
  isSomeVariantsReducedForColour,
  isAllVariantsSaveForColour,
  isSomeVariantsSaveForColour,
};
